import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FadeInOnScrollDirective} from "@cybfed/core/helpers/fade-in-on-scroll.directive";
import {SponsorsModel} from "@white-label/components/page-builder/models/sponsors.model";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {SafePipe} from "@cybfed/shared/pipes/safe.pipe";
import {JsonPipe, NgForOf, NgStyle} from "@angular/common";
import {
    HorizontalCarouselComponent
} from "@white-label/components/carusels/horizontal-carousel/horizontal-carousel.component";
import {
    VerticalCarouselComponent
} from "@white-label/components/carusels/vertical-carousel/vertical-carousel.component";

@Component({
    selector: 'app-sponsors-component',
    standalone: true,
    imports: [
        FadeInOnScrollDirective,
        SafePipe,
        NgStyle,
        HorizontalCarouselComponent,
        NgForOf,
        VerticalCarouselComponent,
        JsonPipe
    ],
    providers: [],
    templateUrl: './sponsors.component.html'
})
export class SponsorsComponent{
    @Input() componentModel: SponsorsModel = new SponsorsModel();


    constructor(public mainStore: MainStoreService) {
    }

    concatSponsors(){
        return [...this.componentModel.sponsors.value, ...this.componentModel.sponsors.value, ...this.componentModel.sponsors.value]
    }

}
